<script setup lang="ts">
/**
 * Invisible component that wires PrimeVue's useToast() to the module-level
 * toast bridge so axios interceptors (and other non-component code) can
 * raise user-facing toasts.
 *
 * Mount once per app alongside <PToast />.
 */
import { onMounted } from 'vue'
import { useToast } from 'primevue/usetoast'
import { setToastInstance } from '../services/toastBridge'

const toast = useToast()

onMounted(() => {
  setToastInstance(toast)
})
</script>

<template>
  <span aria-hidden="true" style="display: none" />
</template>
